<script lang="ts">
	/** `/Checkout/Pay` while it prepares: what is being bought, the address, and the card form. */
	import Bone from './Bone.svelte';
</script>

<div role="status" aria-label="Preparing your payment" class="space-y-4 animate-pulse">
	<div class="widget bg-depth space-y-2">
		<Bone class="h-2.5 w-24" />
		<Bone class="h-4 w-48" />
	</div>
	<div class="widget bg-depth space-y-3">
		<Bone class="h-2.5 w-28" />
		<Bone class="h-10 w-full" round="xl" />
		<Bone class="h-10 w-full" round="xl" />
		<div class="grid gap-3 sm:grid-cols-2">
			<Bone class="h-10 w-full" round="xl" />
			<Bone class="h-10 w-full" round="xl" />
		</div>
	</div>
	<div class="widget bg-depth space-y-3">
		<Bone class="h-24 w-full" round="xl" />
		<Bone class="h-10 w-full" round="xl" />
	</div>
	<span class="sr-only">Loading…</span>
</div>
